<script>
  export let data;
  export let size;
  export let display = "block";
  export let showLabels = "false";

  let labels_top = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
  labels_top = labels_top.filter((l) => l <= data.length);
  let labels_side = ["A", "B", "C", "D", "E", "F", "G", "H"];
  labels_side = labels_side.slice(0, data.length);
  labels_side = ["", ...labels_side];
</script>

<div
  class="container"
  style="display: {display}; width: {size}px; height: {size}px; margin-bottom: 30px"
>
  {#if showLabels}
    <div
      class="labels"
      style="grid-template-columns: {size * 0.2}px 1fr; grid-template-rows: 1fr"
    >
      <div
        class="labels"
        style="grid-template-columns: 1fr; grid-template-rows: repeat({data.length +
          1}, 1fr)"
      >
        {#each labels_side as l}
          <div
            class="label unselectable"
            style="height: {size / (data.length + 1)}px; line-height: {size /
              (data.length + 1)}px;"
          >
            <p>{l}</p>
          </div>
        {/each}
      </div>
      <div
        class="labels"
        style="grid-template-columns: 1fr; grid-template-rows: {size *
          0.2}px 1fr"
      >
        <div
          class="labels"
          style="grid-template-columns: repeat({data.length}, 1fr); grid-template-rows: 1fr"
        >
          {#each labels_top as l}
            <div
              class="label unselectable"
              style="height: {size * 0.2}px; line-height: {size * 0.2}px;"
            >
              <p>{l}</p>
            </div>
          {/each}
        </div>
        <div
          class="matrix"
          style="grid-template-columns: repeat({data.length}, 1fr); grid-template-rows: repeat({data.length}, 1fr);"
        >
          {#each data as line}
            {#each line as e}
              <div
                class="element unselectable"
                style="height: {(size * 0.8) /
                  data.length}px; line-height: {(size * 0.8) / data.length}px"
              >
                <p>{e}</p>
              </div>
            {/each}
          {/each}
        </div>
      </div>
    </div>
  {:else}
    <div
      class="matrix"
      style="grid-template-columns: repeat({data.length}, 1fr); grid-template-rows: repeat({data.length}, 1fr);"
    >
      {#each data as line}
        {#each line as e}
          <div
            class="element unselectable"
            style="height: {size / data.length}px; line-height: {size /
              data.length}px"
          >
            <p>{e}</p>
          </div>
        {/each}
      {/each}
    </div>
  {/if}
</div>

<style>
  .container {
    margin: 0 auto;
  }
  .element p {
    margin: 0;
    vertical-align: middle;
    font-size: 1.5rem;
    font-weight: 700;
    background: -webkit-linear-gradient(#2eb6e8, #1a91bc);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transition: 0.1s ease-out;
  }
  .element p:hover {
    transform: scale(0.8);
  }
  .label {
    text-align: center;
  }
  .label p {
    margin: 0;
    vertical-align: middle;
    color: #999;
  }
  .matrix {
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 0px;
    box-shadow: 2px 2px 10px 3px rgba(0, 0, 0, 0.3);
  }
  .labels {
    width: 100%;
    height: 100%;
    display: grid;
    grid-gap: 0px;
  }
  .element {
    text-align: center;
    background: rgb(#ddd);
    background: linear-gradient(300deg, #ddd 0%, #eee 100%);
    box-shadow: none;
    transition: 0.1s ease-out;
  }
  .element:hover {
    box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
  }
</style>
